import {
  getBookAuthentication,
  // getHwFreeCheckStatusJson,
  // updateHwFreeCheckStatusJson,
  assistanceGetReadpage,
  assistanceSaveReadpage
} from '../../api/answer'
import { getPlatform, timestamp } from '@/static/js/zjs'
import { getOssBookJSON, getOssBookPageJSON } from '../../api/ossBook'
import { transFormBookDataFromNewToOld } from '../utils'
import kebenCookie from '@/cookie/kebenLock'
// import getPlatform from '@/'
export default {
  namespaced: true,
  state: {
    answerRights: '',
    hasAnswerRight: '',
    bookData: {}
  },
  mutations: {
    setAnswerRights(state, payload) {
      state.answerRights = payload
    },
    setHasAnswerRight(state, payload) {
      state.hasAnswerRight = payload
    },
    setBookRightData(state, payload) {
      const { workbookId, data } = payload
      state.bookData = {
        ...state.bookData,
        [workbookId]: {
          ...state.bookData[workbookId],
          ...data
        }
      }
    }
  },
  actions: {
    // 免费看所有答案的特权
    async getAnswerRights({ state, commit, dispatch, rootState }) {
      const { userInfo, openid } = rootState.user
      const { answerRights, hasAnswerRight } = state
      if (hasAnswerRight !== '') {
        return { answerRights, hasAnswerRight }
      }
      // SVIP
      const hasVipRight = userInfo.vipLevel !== 'nv'
      // 作业宝
      const hasBasicServicePaid = userInfo.basicServicePaid === 'Y'
      // 新用户，免费看7天
      const newUserIn7Days =
        userInfo.subscribeTime !== '' &&
        userInfo.subscribeTime &&
        timestamp() - timestamp(userInfo.subscribeTime) <= 7 * 24 * 3600000
      // 机构用户
      const isStoreUserPerm = await dispatch('user/ACTION_getStoreUserPermState', null, {
        root: true
      })
      var hasFree5Pages
      if (!openid) {
        hasFree5Pages = false
      }
      const rights = {
        hasVipRight,
        hasBasicServicePaid,
        newUserIn7Days,
        isStoreUserPerm,
        hasFree5Pages
      }
      const hasRight = Object.values(rights).some(Boolean)
      commit('setAnswerRights', rights)
      commit('setHasAnswerRight', hasRight)
      return { answerRights: rights, hasAnswerRight: hasRight }
    },

    // 书籍类型权限
    async getRightFromCategory({ state }, { category }) {
      // 听写阅读知识点免费阅读
      const platform = getPlatform().platform
      const nowDate = new Date()
      const endDate = new Date('2021/12/31,23:59:59')
      // const endDate = new Date('2021/12/07,15:00:00')
      let shanxiFree
      const leftDate = parseInt(endDate.getTime() - nowDate.getTime()) / 1000
      if (leftDate <= 0) {
        shanxiFree = []
      } else {
        shanxiFree = platform === 'shanxi' ? ['jiaofu', 'keben'] : []
      }
      const freeCategory = [
        'tingxie',
        'zhishidian',
        'yuedu',
        'keben_answer',
        'jiaofu_answer',
        ...shanxiFree
      ]
      console.error(freeCategory)
      if (freeCategory.includes(category)) {
        return true
      } else {
        return false
      }
    },
    // 单本看答案的特权
    async getSingleBookRight(
      { state, commit, dispatch, rootState },
      { workbookId, authentication }
    ) {
      const {
        user: { openid }
      } = rootState
      let bookDataSave
      if (authentication !== undefined) {
        bookDataSave = {
          right: authentication,
          id: workbookId
        }
      } else {
        const res = await getBookAuthentication({ openid, workbookId })
        bookDataSave = {
          right: res.data.authentication,
          price: res.data.price,
          id: workbookId
        }
      }
      commit('setBookRightData', {
        workbookId,
        data: bookDataSave
      })
      return bookDataSave
    },
    // 每天免费看5页检查
    async getFreeCheckStatus(
      { rootState, dispatch },
      { workbookId, pageId, category, save = true }
    ) {
      const {
        user: { openid }
      } = rootState
      const res = await assistanceGetReadpage({ openid })
      const hasReadPagesLength = res.data.data.length < 5
      const hasReadPages = res.data.data
      const hasPageRight = hasReadPages.includes(pageId) || hasReadPagesLength
      // 书籍为学习资料一类的
      const categoryRight = await dispatch('getRightFromCategory', { category })
      if (categoryRight) {
        return true
      }
      if (
        (kebenCookie.get(workbookId) && hasPageRight && category === 'keben') ||
        (hasPageRight && save && category !== 'keben')
      ) {
        await assistanceSaveReadpage({ openid, pageId })
      }
      return hasPageRight
    },
    // 获取书籍前5页
    async getPreIds({ state, commit, dispatch }, { workbookId }) {
      if (state.bookData[workbookId] && state.bookData[workbookId].pre5Ids) {
        return state.bookData[workbookId].pre5Ids
      }
      const { allPages } = await dispatch('getBookContent', { workbookId })
      const pre5Ids = allPages
        .slice(0, 5)
        .map((i) => i.id)
        .map(Number)

      commit('setBookRightData', {
        workbookId,
        data: {
          pre5Ids
        }
      })
      return []
    },
    // 根据书籍id完整地判断权限
    async getCompleteRightByBookId({ state, commit, dispatch }, { workbookId, category }) {
      const { bookData } = state
      const { answerRights, hasAnswerRight } = await dispatch('getAnswerRights')
      const categoryRight = await dispatch('getRightFromCategory', { category })
      if (bookData[workbookId] && bookData[workbookId].right !== undefined) {
        return {
          answerRights,
          hasAnswerRight,
          categoryRight,
          hasRight: hasAnswerRight || bookData[workbookId].right || categoryRight,
          bookData: bookData[workbookId],
          bookRight: bookData[workbookId].right
        }
      }
      const { right, price } = await dispatch('getSingleBookRight', { workbookId })

      const bookDataSave = {
        right,
        price,
        id: workbookId
      }
      commit('setBookRightData', {
        workbookId,
        data: bookDataSave
      })
      return {
        // 作业答案模块的权限列表
        answerRights,
        // 是否有看答案的特权
        hasAnswerRight,
        // 书籍类型权限
        categoryRight,
        // 是否拥有该书的看答案/空白权限
        hasRight: hasAnswerRight || right || categoryRight,
        // 是否购买过该书的特权
        bookRight: right,
        // 该书相关的数据
        bookData: bookDataSave
      }
    },
    // 根据页的排序获取权限判断
    async getPageRightByPageSort({ dispatch }, { workbookId, pageId, category }) {
      const bookRight = await dispatch('getCompleteRightByBookId', { workbookId, category })
      // const ids = await dispatch('getPreIds', { workbookId })
      const hasFree5Pages = await dispatch('getFreeCheckStatus', { workbookId, pageId, category })
      return {
        ...bookRight,
        pageRight: bookRight.hasRight || hasFree5Pages
      }
    },
    // 获取书数据
    async getBookContent({ state, commit }, { workbookId }) {
      const { bookData } = state
      if (bookData[workbookId] && bookData[workbookId].bookJSON) {
        return bookData[workbookId].bookJSON
      }
      const data = await getOssBookJSON(workbookId)
      const bookJSON = {
        ...data,
        ...data.book
      }
      transFormBookDataFromNewToOld(bookJSON)
      commit('setBookRightData', {
        workbookId,
        data: {
          bookJSON
        }
      })
      return bookJSON
    },
    // 获取章数据
    async getChapterJSON({ state, commit, dispatch }, { workbookId, chapterId }) {
      const { bookData } = state
      let cache = {}
      if (bookData[workbookId] && bookData[workbookId].chapterJSON) {
        cache = bookData[workbookId].chapterJSON
      }
      if (cache[chapterId]) {
        return cache[chapterId]
      }
      const data = await getOssBookPageJSON(workbookId, chapterId)
      const bookJSON = await dispatch('getBookContent', { workbookId })
      // 兼容旧数据结构
      data.pages.forEach((item, index) => {
        data.pages[index] = {
          ...item,
          ...bookJSON.allPages.find((i) => i.id === item.id).oldData
        }
      })
      cache[chapterId] = data
      commit('setBookRightData', {
        workbookId,
        data: {
          chapterJSON: cache
        }
      })
      return JSON.parse(JSON.stringify(data))
    },
    // 获取页数据
    async getPageContent({ dispatch }, { workbookId, chapterId, pageId }) {
      const chapterJSON = await dispatch('getChapterJSON', { workbookId, chapterId })
      const pageJSON = JSON.parse(JSON.stringify(chapterJSON.pages.find((i) => i.id === pageId)))
      pageJSON.chapterJSON = chapterJSON
      return pageJSON
    }
  }
}
